import { render, staticRenderFns } from "./AboutServiceAPS.vue?vue&type=template&id=5c4674c4"
import script from "./AboutServiceAPS.vue?vue&type=script&lang=ts"
export * from "./AboutServiceAPS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports